
import Button from '../../../components/base/Button';

export default function ExpertiseSection() {
  const expertiseAreas = [
    {
      icon: 'ri-lightbulb-line',
      title: 'Strategy',
      description: 'Tailored plans to hit your goals with precision and clarity.',
    },
    {
      icon: 'ri-pie-chart-line',
      title: 'Operations',
      description: 'Streamline processes, boost efficiency, and optimize performance.',
    },
    {
      icon: 'ri-rocket-line',
      title: 'Growth',
      description: 'Scale smart with proven tactics and sustainable strategies.',
    }
  ];

  return (
    <section id="expertise" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-light text-gray-900 mb-4">
            What We Do Best
          </h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {expertiseAreas.map((area, index) => (
            <div key={index} className="text-center">
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6">
                <i className={`${area.icon} text-4xl text-gray-700`}></i>
              </div>
              
              <h3 className="text-xl font-medium text-gray-900 mb-4">
                {area.title}
              </h3>
              
              <p className="text-gray-600 mb-6 leading-relaxed font-light">
                {area.description}
              </p>
              
              {area.cta && (
                <button className="text-sm text-gray-700 border-b border-gray-300 hover:border-gray-700 transition-colors font-light whitespace-nowrap cursor-pointer">
                  {area.cta}
                </button>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
